
import './style.css';
import ImageView from "./ImageView"
import { useState } from 'react';
import { useEffect }  from 'react';


function App(props) {

const [centerImg, setCenterImg] = useState("./images/testImg.png");
const [centerName, setCenterName] = useState("World");
 
useEffect(()=>{
  document.getElementById("table" + props.item.id).style.backgroundImage =  "url(" + props.item.bgimg +")";
}, []) 


function onImageClick(img, text){
  setCenterImg(img.replace("_t", "").replace("/thumbnails","").replace("jpg", "png"));
  setCenterName(text);
  document.getElementById("zoomView" + props.item.id).style.display = "block"
}

function onCloseImageClick(){
  document.getElementById("zoomView" + props.item.id).style.display = "none"
  setCenterImg("");
}


  return (
    <div className="bm-main-view">

      <div id={"zoomView" + props.item.id} className='zoom-view'>
        <div className='zoom-view-center'>
          <div className='zoom-view-center-txt'>{centerName}</div>
          <div className='zoom-view-center-close' onClick={()=>{            
            onCloseImageClick()
          }}>X</div>
          <img className='zoom-view-center-img' id={"img1"} src={centerImg} alt={"./images/testImg.png"}/>
        </div>

      </div>

      <div className="text-item " style={{height:30, padding:"10px 0px"}}>

              {
              props.item.header
              }
      </div> 
     
      

<div className='div-table' id={"table"+ props.item.id}>
  <div className='div-tr-nospace'>
    <div className='div-img'><ImageView id={"img1"} src={props.item.description[0].img} text={props.item.description[0].name} alt={props.item.description[0].img} onClick={onImageClick}/></div>
    <div className='div-img'><ImageView id={"img2"} src={props.item.description[1].img} text={props.item.description[1].name} alt={props.item.description[1].img} onClick={onImageClick}/></div>
    <div className='div-img'><ImageView id={"img3"} src={props.item.description[2].img} text={props.item.description[2].name} alt={props.item.description[2].img} onClick={onImageClick}/></div>
    <div className='div-img'><ImageView id={"img4"} src={props.item.description[3].img} text={props.item.description[3].name} alt={props.item.description[3].img} onClick={onImageClick}/></div>
    <div className='div-img'><ImageView id={"img4"} src={props.item.description[4].img} text={props.item.description[4].name} alt={props.item.description[4].img} onClick={onImageClick}/></div>
  </div>
  <div className='div-tr-space'>
   <div className='div-img'><ImageView id={"img9"} src={props.item.description[5].img} text={props.item.description[5].name} alt={props.item.description[5].img} onClick={onImageClick}/></div>
   
    <div className='div-img'><ImageView id={"img5"} src={props.item.description[6].img} text={props.item.description[6].name} alt={props.item.description[6].img} onClick={onImageClick}/></div>
  </div>

  <div  className='div-tr-space'>
    <div className='div-img'><ImageView id={"img6"} src={props.item.description[7].img} text={props.item.description[7].name} alt={props.item.description[7].img} onClick={onImageClick}/></div>
    <div className='div-img'><ImageView id={"img7"} src={props.item.description[8].img} text={props.item.description[8].name} alt={props.item.description[8].img} onClick={onImageClick}/></div>
  </div>

  <div  className='div-tr-space'>
    <div className='div-img'><ImageView id={"img8"} src={props.item.description[9].img} text={props.item.description[9].name} alt={props.item.description[9].img} onClick={onImageClick}/></div>
    <div className='div-img'><ImageView id={"img9"} src={props.item.description[10].img} text={props.item.description[10].name} alt={props.item.description[10].img} onClick={onImageClick}/></div>
  </div>
  
  <div className='div-tr-nospace'>
    <div className='div-img'><ImageView id={"img8"} src={props.item.description[11].img} text={props.item.description[11].name} alt={props.item.description[11].img} onClick={onImageClick}/></div>
    <div className='div-img'><ImageView id={"img9"} src={props.item.description[12].img} text={props.item.description[12].name} alt={props.item.description[12].img} onClick={onImageClick}/></div>
    <div className='div-img'><ImageView id={"img9"} src={props.item.description[13].img} text={props.item.description[13].name} alt={props.item.description[13].img} onClick={onImageClick}/></div>
    <div className='div-img'><ImageView id={"img9"} src={props.item.description[14].img} text={props.item.description[14].name} alt={props.item.description[14].img} onClick={onImageClick}/></div>
    <div className='div-img'><ImageView id={"img9"} src={props.item.description[15].img} text={props.item.description[15].name} alt={props.item.description[15].img} onClick={onImageClick}/></div>
  
  </div> 
</div>
        


 
      <div className="text-item div-footer">

              {
              props.item.description.map((item, key)=>{
                if(key === 0){
                  return item.name
                }else{
                  if( item.name !== ""){
                     return  ", " + item.name 
                  }
                 
                }              
              })
              }
      </div>  
     
     
    </div>
  );
}

export default App;
